import React from 'react';
import PropTypes from 'prop-types';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
  nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caches: caches,
  css: css,
  cx: cx,
  flush: flush,
  getRegisteredStyles: getRegisteredStyles,
  hydrate: hydrate,
  injectGlobal: injectGlobal,
  keyframes: keyframes,
  merge: merge,
  sheet: sheet
});
var styled = createEmotionStyled(emotion, React);
var theme = {
  baseFontSize: 16
}; //DEBTxCYBG pull this from theme component or global?

var baseSpacing = 8;

var spacing = function spacing(value) {
  var fontMultiple = value * baseSpacing;
  var rems = fontMultiple / theme.baseFontSize;
  return rems + "rem";
};

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};
/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
  lewis: {
    xs1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    sm1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    md1: {
      fontSize: 45,
      lineHeight: 1.067
    },
    lg1: {
      fontSize: 52,
      lineHeight: 1.154
    },
    xl1: {
      fontSize: 52,
      lineHeight: 1.154
    }
  },
  skye: {
    xs1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    sm1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    md1: {
      fontSize: 40,
      lineHeight: 1.1
    },
    lg1: {
      fontSize: 45,
      lineHeight: 1.156
    },
    xl1: {
      fontSize: 45,
      lineHeight: 1.156
    }
  },
  shetland: {
    xs1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    sm1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    md1: {
      fontSize: 34,
      lineHeight: 1.176
    },
    lg1: {
      fontSize: 39,
      lineHeight: 1.128
    },
    xl1: {
      fontSize: 39,
      lineHeight: 1.128
    }
  },
  mull: {
    xs1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    sm1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    md1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    lg1: {
      fontSize: 33,
      lineHeight: 1.212
    },
    xl1: {
      fontSize: 33,
      lineHeight: 1.212
    }
  },
  islay: {
    xs1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    sm1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    md1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    lg1: {
      fontSize: 28,
      lineHeight: 1.286
    },
    xl1: {
      fontSize: 28,
      lineHeight: 1.286
    }
  },
  orkney: {
    xs1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    sm1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    md1: {
      fontSize: 22,
      lineHeight: 1.273
    },
    lg1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    xl1: {
      fontSize: 25,
      lineHeight: 1.28
    }
  },
  arran: {
    xs1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 19,
      lineHeight: 1.474
    },
    lg1: {
      fontSize: 21,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 21,
      lineHeight: 1.333
    }
  },
  jura: {
    xs1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    sm1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    md1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    lg1: {
      fontSize: 18,
      lineHeight: 1.556
    },
    xl1: {
      fontSize: 18,
      lineHeight: 1.556
    }
  },
  uist: {
    xs1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    sm1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    md1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    lg1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    xl1: {
      fontSize: 16,
      lineHeight: 1.5
    }
  },
  bute: {
    xs1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    lg1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    xl1: {
      fontSize: 13,
      lineHeight: 1.538
    }
  },
  cumbrae: {
    xs1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    sm1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    md1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    lg1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 12,
      lineHeight: 1.333
    }
  }
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
  var styles = '';

  if (parseInt(mqBreakpoint) === 0) {
    styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
  } else {
    styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      } \n    ';
  }

  return styles;
};

var fontSizes = {};

for (var _fontSize in fontConfig) {
  if (fontConfig.hasOwnProperty(_fontSize)) {
    var style = '';

    for (var breakpoint in fontConfig[_fontSize]) {
      if (fontConfig[_fontSize].hasOwnProperty(breakpoint)) {
        var _fontConfig$_fontSize = fontConfig[_fontSize][breakpoint],
            size = _fontConfig$_fontSize.fontSize,
            lineHeight = _fontConfig$_fontSize.lineHeight;
        style += generateSASS(breakpoints[breakpoint], size, lineHeight);
      }
    }

    fontSizes[_fontSize] = style;
  }
}

var fontSize = function fontSize(font) {
  return fontSizes[font];
};

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n'], ['\n\tcolor: ', ';\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n']);

var getFontProperties = function getFontProperties(props) {
  var fontProperties = 'font-size: 32px; line-height: 1.3125;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('orkney') : fontSize('mull'); // }

  return fontProperties;
};

var StyledPageHeading = styled('h1')(_templateObject, function (props) {
  return props.theme.colours.heading;
}, getFontProperties, function (props) {
  return props.theme.fonts.display.bold;
}, function (props) {
  return !props.isFlush && 'margin-bottom: ' + spacing(3);
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing(2);
});
/**
 * Uses `<h1>` tag internally.
 * @example ./Design.md
 */

var PageHeading = function PageHeading(_ref) {
  var isFlush = _ref.isFlush,
      children = _ref.children;
  return React.createElement(StyledPageHeading, {
    isFlush: isFlush
  }, children);
};

PageHeading.propTypes = {
  /** Allows for content to be text or node (for example IconTextDynamic). */
  children: PropTypes.node.isRequired,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
PageHeading.defaultProps = {
  isFlush: false
};

var _templateObject$1 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n'], ['\n\tcolor: ', ';\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n']);

var getFontProperties$1 = function getFontProperties(props) {
  var fontProperties = 'font-size: 21x; line-height: 1.333;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('jura') : fontSize('orkney'); // }

  return fontProperties;
};

var StyledSectionHeading = styled('h3')(_templateObject$1, function (props) {
  return props.theme.colours.heading;
}, getFontProperties$1, function (props) {
  return props.theme.fonts.display.regular;
}, function (props) {
  return !props.isFlush && 'margin-bottom: ' + spacing(2);
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing(2);
});
/**
 * Uses `<h3>` tag internally.
 * @example ./Design.md
 */

var SectionHeading = function SectionHeading(_ref) {
  var isFlush = _ref.isFlush,
      children = _ref.children;
  return React.createElement(StyledSectionHeading, {
    isFlush: isFlush
  }, children);
};

SectionHeading.propTypes = {
  /** Allows for content to be text or node (for example IconTextDynamic). */
  children: PropTypes.node.isRequired,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
SectionHeading.defaultProps = {
  isFlush: false
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', '\n\tfont-family: ', ';\n\tmargin: 0;\n'], ['\n\tcolor: ', ';\n\t', '\n\tfont-family: ', ';\n\tmargin: 0;\n']),
    _templateObject2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\t', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\t', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n']);

var getFontProperties$2 = function getFontProperties(props) {
  var fontProperties = 'font-size: 25px; line-height: 1.32;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('arran') : fontSize('islay'); // }

  return fontProperties;
};

var StyledSubHeading = styled('h2')(_templateObject$2, function (props) {
  return props.theme.colours.heading;
}, getFontProperties$2, function (props) {
  return props.theme.fonts.display.bold;
});
var StyledWrapper = styled('div')(_templateObject2, function (props) {
  return props.isFlush ? 'margin-bottom: 0' : 'margin-bottom: ' + spacing(2);
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing(2);
}, function (props) {
  return props.theme.colours.heading;
}, function (props) {
  return props.theme.isCompact ? '14px' : '28px';
}, function (props) {
  return props.theme.isCompact ? '8px' : '16px';
}, function (props) {
  return props.theme.isCompact ? '14px' : '28px';
});
/**
 * Uses `<h2>` tag internally.
 * @example ./Design.md
 */

var SubHeading = function SubHeading(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      isFlush = _ref.isFlush;
  return React.createElement(StyledWrapper, {
    isFlush: isFlush
  }, icon, React.createElement(StyledSubHeading, null, children));
};

SubHeading.propTypes = {
  /** Allows for content to be text or node (for example IconTextDynamic). */
  children: PropTypes.node.isRequired,

  /** Optional Left aligned icon with SubHeading. */
  icon: PropTypes.node,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
SubHeading.defaultProps = {
  isFlush: false
};

var _templateObject$3 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tfont-family: ', ';\n\tfont-size: ', ';\n\tfont-weight: 400;\n\tline-height: 1.5;\n\t', ';\n\t', ';\n\tmargin-top: 0;\n\tpadding: 0;\n'], ['\n\tcolor: ', ';\n\tfont-family: ', ';\n\tfont-size: ', ';\n\tfont-weight: 400;\n\tline-height: 1.5;\n\t', ';\n\t', ';\n\tmargin-top: 0;\n\tpadding: 0;\n']);

var StyledWrapper$1 = styled('h4')(_templateObject$3, function (props) {
  return props.theme.colours.heading;
}, function (props) {
  return props.theme.fonts.display.bold;
}, function (props) {
  return props.theme.isCompact ? '14px' : '18px';
}, function (props) {
  return props.isFlush ? 'margin-bottom: 0' : 'margin-bottom: ' + spacing(2);
}, function (props) {
  return props.isFlush ? 'margin-right: 0' : 'margin-right: ' + spacing(2);
});
/**
 * @example ./Design.md
 */

var SubsectionHeading = function SubsectionHeading(_ref) {
  var children = _ref.children,
      isFlush = _ref.isFlush;
  return React.createElement(StyledWrapper$1, {
    isFlush: isFlush
  }, children);
};

SubsectionHeading.propTypes = {
  /** Child content as nodes. */
  children: PropTypes.node.isRequired,

  /** Boolean controlling margin display. */
  isFlush: PropTypes.bool
};
SubsectionHeading.defaultProps = {
  isFlush: false
};

SubsectionHeading.defaultExample = function () {
  return React.createElement(SubsectionHeading, null, 'Heading title');
};

export { PageHeading, SectionHeading, SubHeading, SubsectionHeading };